import { useState, type FormEvent } from "react";

type Status = "idle" | "submitting" | "success" | "error";

interface ParsedResponse {
  code?: string;
  message?: string;
  meta?: { message?: string; detail?: string };
}

export function useFormSubmit(submitAddr: string, successMessage: string) {
  const [status, setStatus] = useState<Status>("idle");
  const [message, setMessage] = useState("");

  const reset = () => {
    setStatus("idle");
    setMessage("");
  };

  const submit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const form = event.currentTarget;
    const formData = new FormData(form);

    const honeypot = ((formData.get("website_alt") as string) || "").trim();
    if (honeypot) {
      setStatus("success");
      setMessage(successMessage);
      form.reset();
      return;
    }

    const payload = new URLSearchParams();
    formData.forEach((value, key) => {
      if (key === "website_alt") return;
      payload.append(key, value as string);
    });

    setStatus("submitting");
    setMessage("");

    try {
      const response = await fetch(submitAddr, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: payload.toString(),
      });

      const responseText = await response.text();
      let parsed: ParsedResponse | null = null;
      try {
        parsed = JSON.parse(responseText) as ParsedResponse;
      } catch {
        parsed = null;
      }

      const code = parsed?.code;
      const serverMsg =
        parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText || "";
      const isSpam = typeof serverMsg === "string" && serverMsg.toLowerCase().includes("spam");

      if (response.ok && code === "OK") {
        setStatus("success");
        setMessage(successMessage);
        form.reset();
      } else {
        setStatus("error");
        setMessage(
          isSpam
            ? "提交未通过校验，请检查内容后重新提交。"
            : serverMsg || "提交失败，请稍后重试。"
        );
      }
    } catch {
      setStatus("error");
      setMessage("网络异常，提交没有成功，请稍后重试。");
    }
  };

  return { status, message, submit, reset };
}

export default useFormSubmit;